import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FirebaseService } from '../services/firebase.service';
import { filter, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private firebase: FirebaseService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.firebase.currentUser$.pipe(
      filter(user => user !== undefined),
      take(1),
      map(user => {
        if (user) {
          const isChangePasswordRoute = state.url.endsWith('/change-password');
          if (this.firebase.mustChangePassword && !isChangePasswordRoute) {
            // 强制变更密码
            this.router.navigate(['/pages/change-password']);
            return false;
          }

          const expectedRoles = route.data['roles'] as string[];
          const permissions = this.firebase.getPermissions();
      
          if (expectedRoles.includes('all') 
            || (permissions.canEntry && expectedRoles.includes('canEntry'))
            || (permissions.isAdmin && expectedRoles.includes('isAdmin'))
          ) {
            return true;
          } else {
            // 没有权限，重定向或提示
            this.router.navigate(['/pages/unauthorized']);
            return false;
          }

          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }
}
